export const truncate = (str: string | null | undefined, length: number) => {
  if (!str) return str
  let dots = str.length > length ? "..." : ""
  return str.substring(0, length) + dots
}

/**
 * Splits text into two parts based on a character limit per line
 * @param text The text to split
 * @param charLimit Maximum characters per line (default: 12)
 * @returns An array with two strings - first line and second line (with ellipsis if truncated)
 */
export const balanceText = (text: string | null, charLimit = 12): [string, string] => {
  if (!text) return ["", ""]

  if (!text.includes(" ")) {
    if (text.length <= charLimit) return [text, ""]
    return [text.substring(0, charLimit - 3) + "...", ""]
  }

  const words = text.split(" ")
  const totalLength = text.length

  // If text can fit within two lines, balance it
  if (totalLength <= charLimit * 2) {
    // Find the best split point for balanced lines
    let bestSplitIndex = 1
    let bestDifference = Number.MAX_VALUE
    const halfLength = totalLength / 2

    for (let i = 1; i < words.length; i++) {
      const firstPartLength = words.slice(0, i).join(" ").length
      const difference = Math.abs(firstPartLength - halfLength)

      if (difference < bestDifference) {
        bestDifference = difference
        bestSplitIndex = i
      }
    }

    return [words.slice(0, bestSplitIndex).join(" "), words.slice(bestSplitIndex).join(" ")]
  }

  // Otherwise, maximize first line and truncate second if needed
  let firstLine = words[0]
  let i = 1

  // Add words to first line until we reach the limit
  while (i < words.length && firstLine.length + 1 + words[i].length <= charLimit) {
    firstLine += " " + words[i]
    i++
  }

  // If all words fit in first line
  if (i >= words.length) return [firstLine, ""]

  // Create and possibly truncate second line
  let secondLine = words.slice(i).join(" ")
  if (secondLine.length > charLimit) {
    secondLine = secondLine.substring(0, charLimit - 3) + "..."
  }

  return [firstLine, secondLine]
}
